import ActivitesOrder from './ActivitesOrder.vue';

export default ActivitesOrder;



// WEBPACK FOOTER //
// ./src/pages/activities/card/order/index.ts